import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { PublishedConnectionCountsRequestAction } from '~src/publishedConnection/actions/PublishedConnectionCountsRequestAction';
import { clearSpaceContentCountsAction, contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';

export function* handlePublishedConnectionCountsRequest(action: PublishedConnectionCountsRequestAction): SagaIterator {
  yield put(clearSpaceContentCountsAction(action.spaceType));
  yield put(contentCountsRequest());
}
